import theme from '@ifca-root/react-component/src/assets/theme'
import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList'
import DynamicSubHeader from '@ifca-root/react-component/src/components/Header/DynamicSubHeader'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { SearchHeader } from '@ifca-root/react-component/src/components/Header/SearchHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import { CircularProgress, List, useMediaQuery } from '@material-ui/core'
import { advancedFilterList } from 'components/Filter/AdvancedFilter'
import AuditLogTable from 'components/Table/AuditLogTable'
import { useAuditLogDetailsLazyQuery } from 'generated/graphql'
import { useFuseSearch } from 'helpers/Hooks/useSearch'
import React, { useEffect, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useHistory, useLocation, useParams } from 'react-router'

export const AuditLogListing = (props: any) => {
  const { smTitle, routeSegments, module } = props

  let history = useHistory()
  const { CompanyID }: any = useParams()
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  })
  const user = JSON.parse(localStorage.getItem('loggedInUser'))
  let location = useLocation()
  let data: any = location.state

  type AuditFieldChange = {
    ReadableFieldName: string
    OldValue: string
    NewValue: string
  }

  type AuditLogItem = {
    eventID: string
    ActionDate: string
    Action: string
    ModifiedByUserName: string
    CreatedByUserName: string
    FieldChanges: AuditFieldChange[]
  }
  const [TotalItemLength, setTotalItemLength] = useState(0)
  const [auditData, setAuditData] = useState<AuditLogItem[]>([])
  const [hasMore, setHasMore] = useState(true)
  const [
    loadAuditLog,
    {
      loading: AuditLogDetailsLoading,
      data: { AuditLogDetails } = { AuditLogDetails: [] },
    },
  ] = useAuditLogDetailsLazyQuery({
    fetchPolicy: 'network-only',
    onCompleted: ({ AuditLogDetails }) => {
      if (AuditLogDetails?.length > 0) {
        setAuditData(prev => [...prev, ...AuditLogDetails])
        setOriginalListing(prev => [...prev, ...AuditLogDetails])

        const newLength = AuditLogDetails.reduce(
          (sum, item) => sum + (item.TotalLength || 0),
          0
        )

        setTotalItemLength(prev => {
          const updated = prev + newLength

          // Kalau result kurang 30 fields → takde data dah
          if (newLength < 30) setHasMore(false)

          return updated
        })
      } else {
        setHasMore(false)
      }
    },
  })

  useEffect(() => {
    setOriginalListing([])
    loadAuditLog({
      variables: {
        TableName: data?.tableName,
        primaryKey: data?.primaryKey,
        primaryItemKey: data?.primaryItemKey,
        FieldID: data?.ID,
        skip: 0,
        take: 30,
      },
    })
  }, [])

  //to make delay for search function for the query to load
  const [timer, setTimer] = useState(null)
  function changeDelay(change) {
    if (timer) {
      clearTimeout(timer)
      setTimer(null)
    }
    setTimer(
      setTimeout(() => {
        setOriginalListing([])
        loadAuditLog({
          variables: {
            TableName: data?.tableName,
            primaryKey: data?.primaryKey,
            primaryItemKey: data?.primaryItemKey,
            FieldID: data?.ID,
            skip: 0,
            take: 30,
          },
        })
      }, 1000)
    )
  }

  /* -------------------------------------------- */
  /*                    SEARCH                    */
  /* -------------------------------------------- */

  const {
    filteredList,
    handleSearch,
    setOriginalListing,
    originalList,
  } = useFuseSearch()

  return (
    <>
      {AuditLogDetailsLoading && <Loading />}

      <MainHeader
        mainBtn="back"
        onClick={() => {
          history.goBack()
          localStorage.removeItem(`searchFilter`)
          localStorage.removeItem(`advancedFilter`)
        }} //<- back button action
        smTitle={smTitle}
        title={user?.companyName}
        routeSegments={
          module === 'mfrs16' ||
          module === 'cash-book' ||
          module === 'account-receivable' ||
          module === 'general-purchases' ||
          module === 'inventory control'
            ? [{ name: 'Main Menu' }, { name: routeSegments, current: true }]
            : [
                { name: 'Main Menu' },
                { name: 'Previous Path' },
                { name: 'Previous Path' },
                { name: routeSegments, current: true },
              ]
        }
      />

      {module === 'ledger' ? (
        <DynamicSubHeader
          title={
            <span className="c-orange">
              <span style={{ fontWeight: 'bold' }}>
                {data?.DocNo ?? data?.RefNo}
              </span>
            </span>
          }
          rightText={
            <span>
              <span style={{ fontWeight: 'bold' }}>{'Audit Log'}</span>
            </span>
          }
        />
      ) : (
        <DynamicSubHeader
          title={
            <span>
              <span style={{ fontWeight: 'bold' }}>{'Audit Log'}</span>
            </span>
          }
        />
      )}

      <div className="search-filter with-dropdown-filter ">
        <SearchHeader
          title={`Search here`}
          value={`${filteredList?.length}`}
          search
          onChangeAction={e => {
            handleSearch(e?.target?.value, [
              'Action',
              'ActionDate',
              'ReadableFieldName',
              'FieldName',
            ])
            changeDelay(e?.target?.value)
          }}
          onCloseAction={() => {
            handleSearch('', [])
            setOriginalListing([])
            loadAuditLog({
              variables: {
                TableName: data?.tableName,
                primaryKey: data?.primaryKey,
                primaryItemKey: data?.primaryItemKey,
                FieldID: data?.ID,
                skip: 0,
                take: 30,
              },
            })
          }}
        />
      </div>
      <ContentWrapper footer overflow>
        <List className="core-list">
          {advancedFilterList(filteredList) === undefined ||
          advancedFilterList(filteredList)?.length === 0 ? (
            <EmptyList
              title="No Record found"
              subtitle="Add a new record now."
            />
          ) : (
            <InfiniteScroll
              dataLength={filteredList?.length}
              next={() => {
                loadAuditLog({
                  variables: {
                    TableName: data?.tableName,
                    primaryKey: data?.primaryKey,
                    primaryItemKey: data?.primaryItemKey,
                    FieldID: data?.ID,
                    take: 30,
                    skip: TotalItemLength,
                  },
                })
              }}
              hasMore={hasMore}
              className=""
              style={{ padding: '8px 6px' }}
              loader={
                AuditLogDetailsLoading && (
                  <div style={{ textAlign: 'center' }}>
                    {' '}
                    <CircularProgress />{' '}
                  </div>
                )
              }
              endMessage={
                <p style={{ textAlign: 'center' }}>
                  <b>-</b>
                </p>
              }
            >
              <AuditLogTable auditLogs={auditData} />
            </InfiniteScroll>
          )}
        </List>
      </ContentWrapper>
    </>
  )
}
